<template>
    <div class="home" style="width: 100%">
        <AuthCheck :show="show" :is_auth="is_auth" :is_auth_check="is_auth_check" :userData="userData" @goEdit="goEdit" />
        <Cpm v-if="!show && is_auth === 1 && is_auth_check === 1" :pmType="2" />
        <completeInformation v-if="show" />
    </div>
</template>
  
<script>
import { api1, api2, api3, api4, api6 } from '@/api/index.js'
import Cpm from '../../components/Cpm.vue'
import completeInformation from '../../components/completeInformation.vue'
import AuthCheck from '../../components/AuthCheck.vue'


export default {
    data() {
        return {
            show: false,
            is_auth: null,
            is_auth_check: null,
            userData: {}
        }
    },
    components: { Cpm, completeInformation, AuthCheck },
    mounted() {
        this.qx()
    },
    methods: {
        goEdit() {
            this.show = true;
        },
        qx() {
            api6({ id: JSON.parse(localStorage.getItem('userInfo')).id }).then(res => {
                if (res.data.code === 1) {
                    // 1:已认证  0：未认证
                    this.is_auth = res.data.data.user.is_auth
                    this.is_auth_check = res.data.data.user.is_auth_check
                    this.userData = res.data.data.user
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
    }
}
</script>
  
<style scoped>
.tishi {
    font-weight: 400;
    font-size: 14px;
    color: #E90000;
    margin-top: 20px;
}

.pm-box {
    width: 100%;
    height: 100%;
    padding: 10px 25px;
    box-sizing: border-box;
    background: #fff;
}

.text2 {
    font-weight: 400;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 28px;
}

.text1 {
    font-weight: 400;
    font-size: 40px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 41px;
}

.homepic {
    width: 328px;
    height: 379px;
}

.home {
    width: 100%;
    height: 100%;
    background: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
  


// WEBPACK FOOTER //
// src/view/PM/finished.vue